import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IndeterminateCheckBoxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"indeterminate_check_box"}/>
}
